import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchInvestmentBasicInfo } from '@apis/investmentIndicators';
import type { InvestmentBasicInfoApiData } from '@app-types/investmentIndicatorsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

export const useInvestmentBasicInfo = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<InvestmentBasicInfoApiData>({
    queryKey: ['indicators', 'basic-info', ticker, mkt],
    queryFn: () => fetchInvestmentBasicInfo({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};

